import { useContext } from 'react';
import NavbarContext from 'context/NavbarContext';

export default () => useContext(NavbarContext);
